export default __webpack_public_path__ + "static/media/175.c8a920b5.jpg";